export default {
  siteWidth: 1200,
  breakpoints: ['370px', '576px', '852px', '968px', '1080px'],
  mediaQueries: {
    xs: '@media screen and (min-width: 370px)',
    sm: '@media screen and (min-width: 576px)',
    md: '@media screen and (min-width: 852px)',
    lg: '@media screen and (min-width: 968px)',
    xl: '@media screen and (min-width: 1080px)',
    nav: '@media screen and (min-width: 968px)',
  },
  spacing: [0, 4, 8, 16, 24, 32, 48, 64],
  shadows: {
    level1: '0px 2px 12px -8px rgba(25, 19, 38, 0.1), 0px 1px 1px rgba(25, 19, 38, 0.05)',
    active: '0px 0px 0px 1px #0098A1, 0px 0px 4px 8px rgba(31, 199, 212, 0.4)',
    success: '0px 0px 0px 1px #31D0AA, 0px 0px 0px 4px rgba(49, 208, 170, 0.2)',
    warning: '0px 0px 0px 1px #ED4B9E, 0px 0px 0px 4px rgba(237, 75, 158, 0.2)',
    focus: '0px 0px 0px 1px #7645D9, 0px 0px 0px 4px rgba(118, 69, 217, 0.6)',
    inset: 'inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)',
  },
  radii: { small: '4px', default: '16px', card: '10px', circle: '50%' },
  zIndices: { dropdown: 10, modal: 100 },
  isDark: true,
  alert: { background: '#1E272E' },
  button: {
    primary: {
      background: '#752F8A',
      backgroundActive: '#067FDC',
      backgroundHover: '#067FDC',
      border: 0,
      borderColorHover: 'currentColor',
      boxShadow: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
      boxShadowActive: 'inset 0px -1px 0px rgba(14, 14, 44, 0.4)',
      color: '#FFFFFF',
    },
    secondary: {
      background: 'transparent',
      backgroundActive: 'transparent',
      backgroundHover: 'transparent',
      border: '2px solid #752F8A',
      borderColorHover: '#752F8A',
      boxShadow: 'none',
      boxShadowActive: 'none',
      color: '#752F8A',
    },
    tertiary: {
      background: '#353547',
      backgroundActive: '#353547',
      backgroundHover: '#353547',
      border: 0,
      borderColorHover: 'currentColor',
      boxShadow: 'none',
      boxShadowActive: 'none',
      color: '#E79AFC',
    },
    text: {
      background: 'transparent',
      backgroundActive: 'transparent',
      backgroundHover: '#353547',
      border: 0,
      borderColorHover: 'currentColor',
      boxShadow: 'none',
      boxShadowActive: 'none',
      color: '#E79AFC',
    },
    danger: {
      background: '#ED4B9E',
      backgroundActive: '#D43285',
      backgroundHover: '#FF65B8',
      border: 0,
      borderColorHover: 'currentColor',
      boxShadow: 'none',
      boxShadowActive: 'none',
      color: '#FFFFFF',
    },
    subtle: {
      background: '#8f80ba',
      backgroundActive: '#8f80baD9',
      backgroundHover: '#8f80baB3',
      border: 0,
      borderColorHover: 'currentColor',
      boxShadow: 'none',
      boxShadowActive: 'none',
      color: '#FFFFFF',
    },
    success: {
      background: '#31D0AA',
      backgroundActive: '#31D0AAD9',
      backgroundHover: '#31D0AAB3',
      border: 0,
      borderColorHover: 'currentColor',
      boxShadow: 'none',
      boxShadowActive: 'none',
      color: '#FFFFFF',
    },
  },
  colors: {
    hamburgerIcon: '#752F8A',
    failure: '#ED4B9E',
    primary: '#31FCEE',
    primaryBright: '#aa8929',
    primaryDark: '#0098A1',
    secondary: '#00C2F9',
    success: '#31D0AA',
    warning: '#FFB237',
    binance: '#F0B90B',
    background: '#2B3437',
    backgroundDisabled: '#3c3742',
    contrast: '#FFFFFF',
    invertedContrast: '#191326',
    input: '#483f5a',
    tertiary: '#353547',
    text: '#EAE2FC',
    textDisabled: '#666171',
    textSubtle: '#E79AFC',
    borderColor: '#524B63',
    card: '#1E272E',
    gradients: { bubblegum: 'linear-gradient(139.73deg, #313D5C 0%, #3D2A54 100%)' },
  },
  card: {
    background: '#1E272E',
    boxShadow: '0px 2px 12px -8px rgba(25, 19, 38, 0.1), 0px 1px 1px rgba(25, 19, 38, 0.05)',
    boxShadowActive: '0px 0px 0px 1px #0098A1, 0px 0px 4px 8px rgba(31, 199, 212, 0.4)',
    boxShadowSuccess: '0px 0px 0px 1px #31D0AA, 0px 0px 0px 4px rgba(49, 208, 170, 0.2)',
    boxShadowWarning: '0px 0px 0px 1px #ED4B9E, 0px 0px 0px 4px rgba(237, 75, 158, 0.2)',
    cardHeaderBackground: 'linear-gradient(166.77deg, #3B4155 0%, #3A3045 100%)',
    dropShadow: 'drop-shadow(0px 1px 4px rgba(25, 19, 38, 0.15))',
  },
  toggle: { handleBackground: '#1E272E' },
  nav: { topBackground: '#E79AFC', background: '#1E272E', hover: '#473d5d' },
  modal: { background: '#1E272E' },
  radio: { handleBackground: '#1E272E' },
}
